import React from "react";
import ChartCard from "./components/ChartCard";
import StakingCard from "./components/StakingCard";
import StakingLeaderboard from "./components/StakingLeaderboard";

const Staking = () => {
	return (
		<section className="section-gap">
			<div className="container">
				<div
					className="row g-2 g-sm-3 g-lg-4 justify-content-center"
					style={{ marginBottom: "24px" }}
				>
					<div className="col-lg-4 col-md-6">
						<div className="__stake-count-badge">
							<span>APR:</span>
							<span>25%</span>
						</div>
					</div>
					<div className="col-lg-4 col-md-6">
						<div className="__stake-count-badge">
							<span>Stakers:</span>
							<span>462</span>
						</div>
					</div>
					<div className="col-lg-4 col-md-6">
						<div className="__stake-count-badge">
							<span>Total Staked </span>
							<span>482K ANT-P</span>
						</div>
					</div>
				</div>
				<div className="row g-4">
					<div className="col-lg-6">
						<div className="row g-4">
							<div className="col-12">
								<ChartCard />
							</div>
							<div className="col-12">
								<StakingLeaderboard />
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<StakingCard />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Staking;
